// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"forum_tooltip__13MSc","forumDisabledDialog":"forum_forumDisabledDialog__2wdeJ"};